import type { VerificationResultValues } from '@repo/common';

import { useTranslation } from 'react-i18next';

import { useAppContext } from '@/providers/app-provider/context';

export function useResultText(result: VerificationResultValues): {
  mobileRedirectInfo?: string;
  redirectButton?: string;
  retryButton?: string;
  subtitle?: string;
  title: string;
} {
  const { t } = useTranslation();
  const { state } = useAppContext();
  const flow = state.customFlowType;

  // Try per-flow overrides first, then fall back to generic keys
  const flowTitle = (t(`steps.verificationResultByFlow.${flow}.${result}.title`, { defaultValue: '' }) as string) || '';
  const flowSubtitle =
    (t(`steps.verificationResultByFlow.${flow}.${result}.subtitle`, { defaultValue: '' }) as string) || '';

  const title = flowTitle || t(`steps.verificationResult.${result}.title`);
  const subtitle =
    flowSubtitle || (t(`steps.verificationResult.${result}.subtitle`, { defaultValue: '' }) as string) || undefined;

  const mobileRedirectInfo =
    (t(`steps.verificationResult.${result}.mobileRedirectInfoText`, { defaultValue: '' }) as string) || undefined;

  const redirectButton =
    (t(`steps.verificationResult.${result}.redirectButton`, { defaultValue: '' }) as string) || undefined;

  const retryButton =
    (t(`steps.verificationResult.${result}.retryButton`, { defaultValue: '' }) as string) || undefined;

  return {
    title,
    subtitle,
    retryButton,
    redirectButton,
    mobileRedirectInfo,
  };
}
